/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { useAuth0 } from "@auth0/auth0-react";
import { GET_ITINERARY_FULL } from "./graphQL/queries";
import { useLazyQuery } from "@apollo/client";
import Webflow from "./components/tripOverview/webflow";
import Overview from "./components/tripOverview/overview";
import Loader from "./components/tripOverview/Common/Loader";
import { ItineraryFull } from "./atom/Types";
import { HandleLogin } from "./atom/utilities/function";
import ShoppingCart from "./components/tripOverview/ShoppingCart";
// const Payment = lazy(() => import('./components/Payment'))

interface props {
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>
}

const RouterConfig: React.FC<props> = ({ refetch }) => {
    const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

    const { id } = useParams()
    const [getItineraryData, { data: ItineraryData, refetch: getItineraryRefetch, loading: Itineraryload }] = useLazyQuery<ItineraryFull>(GET_ITINERARY_FULL, {
        variables: { key: id }
    });
    const navigate = useNavigate()
    useEffect(() => {
        if (id !== 'webflow') {


            getItineraryData().then((b) => {
                if (b.error) {
                    throw b.error.message;
                }
            }).catch(() => {


            })
        }
    }, [])

    const redirectFun = async (path: string) => {


        if (isAuthenticated)
            navigate(path)
        else {
            navigate(path)
            await HandleLogin(loginWithRedirect, logout, isAuthenticated)
        }
    }


    return <div>
        {(ItineraryData && ItineraryData?.queryItinerary?.length > 0 && !Itineraryload) || id === 'webflow' ? <Routes>
            {id === 'webflow' ? <Route
                path="/"
                element={
                    <React.Suspense fallback={<></>}>
                        <Webflow />
                    </React.Suspense>
                }
            /> : <>
                {isAuthenticated ? <>
                    <Route
                        path="/"
                        element={<React.Suspense fallback={<Loader content='Loading...' />}>
                            <Overview redirectFun={redirectFun} refetch={refetch} BuilderData={ItineraryData} getItineraryRefetch={getItineraryRefetch} loading={Itineraryload} />
                        </React.Suspense>} />
                    <Route
                        path="/payment"
                        element={<React.Suspense fallback={<></>}>
                            payment
                        </React.Suspense>} />
                    <Route
                        path="/cart"
                        element={<React.Suspense fallback={<Loader content={"Loading..."} />}>

                            {ItineraryData && <ShoppingCart ItineraryData={ItineraryData} />}
                        </React.Suspense>} /></> : window.location.pathname.split('/')[4] ?
                    loginWithRedirect({
                        appState: {
                            returnTo: '/viewer/'
                        }
                    }) : <Route
                        path="/"
                        element={<React.Suspense fallback={<Loader content='Loading...' />}>
                            <Overview redirectFun={redirectFun} refetch={refetch} BuilderData={ItineraryData} getItineraryRefetch={getItineraryRefetch} loading={Itineraryload} />
                        </React.Suspense>} />
                }</>}

        </Routes> : ItineraryData && ItineraryData?.queryItinerary?.length === 0 && !Itineraryload ? <Loader redirectFun={redirectFun} content="invalid url , you will be automatically redirected to profile in 5 sec" /> : <Loader content='Loading' />}
    </div>
}

export default RouterConfig


